<template>
  <!-- Manual call status Modal -->
  <div class="modal fade hl_add-event-modal" id="add-event-modal" tabindex="-1" role="dialog" ref="modal">
    <div class="modal-dialog --small" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header--inner">
            <h5 class="modal-title">{{ $t('common.how_did_the_call_go') }}</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-body-inner">
            <div class="row">
              <div class="col-sm-6">
                <a @click.prevent="selected('no-answer')">
                  <i class="icon fa fa-ban"></i>
                  <h4>{{ $t('common.no_answer') }}</h4>
                </a>
              </div>
              <div class="col-sm-6">
                <a @click.prevent="selected('busy')">
                  <i class="icon fas fa-phone-slash"></i>
                  <h4>{{ $t('common.busy') }}</h4>
                </a>
              </div>
              <div class="col-sm-6">
                <a @click.prevent="selected('voicemail')">
                  <i class="icon icon-mic"></i>
                  <h4>{{ $t('common.voicemail') }}</h4>
                </a>
              </div>
              <div class="col-sm-6">
                <a @click.prevent="selected('completed')">
                  <i class="icon fas fa-check-circle"></i>
                  <h4>{{ $t('common.completed') }}</h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import { ManualCallStatusState } from '../../store/state_models'
import { useEmitter } from '@/pmd/composition/useEmitter'
declare let $: any
export default defineComponent({
  data() {
    return {
      firstClick: true,
      emitter: useEmitter(),
    }
  },
  methods: {
    selected(type: string) {
      if (this.firstClick) {
        this.firstClick = false
      }
      this.emitter.emit('callNextManual', this.manualCallId, type)
      this.emitter.emit('dialer:callNextManual', type)
      this.$store.commit('manualCallStatus/hide')
    },
  },
  computed: {
    ...mapState('manualCallStatus', {
      manualCallId: (s: ManualCallStatusState) => {
        return s.manualCallId
      },
    }),
  },
  watch: {
    manualCallId: function (manualCallId: string) {
      const _self = this
      console.info(manualCallId)
      if (manualCallId) {
        $(_self.$refs.modal).modal('show')
      } else {
        $(_self.$refs.modal).modal('hide')
      }
    },
  },
  mounted() {
    $(this.$refs.modal).modal({
      backdrop: 'static',
      keyboard: false,
      show: false,
    })
  },
})
</script>
